import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import "./AddMenaceModal.css";

const AddMenaceModal = ({ show, onClose, onCreated, showToast }) => {
  const [form, setForm] = useState({
    name: "",
    categorie: "",
    gravity: 1,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: name === "gravity" ? parseFloat(value) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch("/api/add_menace.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();
      if (data.success) {
        showToast("Menace ajoutée !");
        onCreated?.();
        onClose();
      } else {
        showToast(data.error || "Erreur lors de l'ajout", "danger");
      }
    } catch (err) {
      showToast("Erreur réseau", "danger");
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      backdrop="static"
      centered
      dialogClassName="add-menace-modal"
    >
      <Form onSubmit={handleSubmit}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="bi bi-exclamation-triangle me-2 text-warning" />
              Ajouter une Menace
            </h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            {/* 🔹 Nom */}
            <div className="mb-3">
              <Form.Label>Nom</Form.Label>
              <Form.Control
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                placeholder="Ex: Ransomware externe"
              />
            </div>

            {/* 🔹 Catégorie */}
            <div className="mb-3">
              <Form.Label>Catégorie</Form.Label>
              <Form.Control
                name="categorie"
                value={form.categorie}
                onChange={handleChange}
                placeholder="Ex: Cyber, Physique..."
              />
            </div>

            {/* 🔹 Gravité */}
            <div className="mb-3">
              <Form.Label>Gravité (1 à 4)</Form.Label>
              <Form.Control
                type="number"
                name="gravity"
                min="1"
                max="4"
                step="0.1"
                value={form.gravity}
                onChange={handleChange}
              />
              <small className="text-secondary">Niveau d’impact estimé</small>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-profile" onClick={onClose}>
              Annuler
            </button>
            <button type="submit" className="btn-profile btn-success">
              Ajouter
            </button>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default AddMenaceModal;
